module.exports = __webpack_public_path__ + "static/media/englishPage6.7c9ecc9b.jpg";